import { render, staticRenderFns } from "./show_parent_c.vue?vue&type=template&id=93f07a56"
import script from "./show_parent_c.vue?vue&type=script&lang=js"
export * from "./show_parent_c.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports